export default {
  live_access: 'boolean'
}



// WEBPACK FOOTER //
// ./src/store/models/userticket.js